import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';
import { useAuthStore } from '../stores/authStore';

/**
 * A custom hook that provides standardized logout functionality
 * @returns An object containing the handleLogout function
 */
export function useLogout() {
  const { clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      // First clear local auth state
      clearAuth();
      
      // Then properly log out from Microsoft and redirect
      await authApi.logout();
      
      // Note: authApi.logout should redirect, but if it doesn't, we still
      // want to ensure we're on the login page
    } catch (error) {
      console.error('Logout failed:', error);
      
      // If Microsoft logout fails, still clear local state and redirect
      clearAuth();
      
      // Use navigate if available (from react-router), otherwise fallback to location.href
      if (navigate) {
        navigate('/login');
      } else {
        window.location.href = '/login';
      }
    }
  }, [clearAuth, navigate]);

  return { handleLogout };
} 